import { TopBanner } from '../../../shared/components/banner/TopBanner';
import { useSuspendedEligibilityBannersQuery } from '../../SubmissionAPI';

export function EligibilityBanner() {
  const { data: banners } = useSuspendedEligibilityBannersQuery();
  return (
    <ul>
      {banners.map((banner) => {
        return (
          <li key={banner.id}>
            <TopBanner banner={banner} language="en" />
          </li>
        );
      })}
    </ul>
  );
}
